import request from '@/utils/request'

// 查询维修产品项列表分页
export function fetchList(query) {
    return request({
        url: '/upkeep/prod/sku/list',
        method: 'get',
        params: query,
    })
}
// 查询维修话术详细
export function getObj(id) {
    return request({
        url: '/upkeep/script/detail?id=' + id,
        method: 'get',
    })
}
// 新增维修话术
export function addObj(data) {
    return request({
        url: '/upkeep/script/add',
        method: 'post',
        data: data,
    })
}
// 禁用启用 维修首页状态
export function statusObj(data) {
    return request({
        url: '/upkeep/prod/sku/status',
        method: 'post',
        data: data,
    })
}
// 修改维修话术
export function putObj(data) {
    return request({
        url: '/upkeep/script/edit',
        method: 'post',
        data: data,
    })
}
// 删除维修话术
export function delObj(data) {
    return request({
        url: '/upkeep/script/delete',
        method: 'post',
        data: data,
    })
}
